import Component from 'vue-class-component'
import Vue from 'vue'
import { Watch } from 'vue-property-decorator'

@Component({
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: '埋め込みコードの編集'
    },
    submitLabel: {
      type: String,
      required: false,
      default: '保存'
    }
  }
})
export default class EmbedEditor extends Vue {
  readonly value: string
  readonly title: string
  readonly submitLabel: string
  content: string = ''

  created(): void {
    this.initializeContent()
  }

  mounted(): void {
    // 埋め込みコンテンツの入力欄にフォーカスを移動する
    (<HTMLInputElement>this.$refs.content).focus()
  }

  @Watch('value')
  initializeContent(): void {
    this.content = this.value
  }

  close(): void {
    this.$emit('close')
  }

  submit(): void {
    this.$emit('submit', this.content)
  }

  emitInputText(): void {
    this.$emit('input')
  }
}
